import {
  UsergroupAddOutlined,
  UserOutlined,
  ReadOutlined,
  FileExcelOutlined,
  WhatsAppOutlined,
  MessageFilled,
} from "@ant-design/icons";
import { Divider } from "antd";
import "./index.css";
import { HiOutlineCurrencyRupee } from "react-icons/hi2";
import { BiCreditCard, BiRightArrowAlt } from "react-icons/bi";

const TableData = [
  {
    name: "1",
    category: "Musk",
    mobile: "777",
    partyType: "partyType",
    balance: "Balance",
  },
  {
    name: "2",
    category: "Andrew",
    mobile: "777",
    partyType: "Data",
    balance: "Balance",
  },
];
const vendorHeaders = [
  {
    label: "All Vendor",
    key: "1",
    icon: <UsergroupAddOutlined />,
    vendor: "1",
    color: "blue",
  },
  // {
  //   label: "To Collect",
  //   key: "2",
  //   icon: <HiOutlineCurrencyRupee size={16} />,
  //   amount: "₹ 0",
  //   color: "green",
  // },
  {
    label: "To Pay",
    key: "3",
    icon: <HiOutlineCurrencyRupee size={16} />,
    amount: "₹ 0",
    color: "red",
  },
];

const itemHeaders = [
  {
    key: "itemName",
    title: "Item Name",
    dataIndex: "itemName",
    sorter: (a, b) => a.date.length - b.date.length,
  },
  {
    key: "itemCode",
    title: "Item Code",
    dataIndex: "itemCode",
  },
  {
    key: "stockQTY",
    title: "Sales Quantity",
    dataIndex: "stockQTY",
  },
  {
    key: "salesPrice",
    title: "Sales Amount",
    dataIndex: "salesPrice",
    sorter: (a, b) => a.salesPrice.length - b.salesPrice.length,
  },
  {
    key: "categoryName",
    title: "Category Name",
    dataIndex: "categoryName",
  },
  {
    key: "purchasePrice",
    title: "purchase Amount",
    dataIndex: "purchasePrice",
    sorter: (a, b) => a.purchasePrice.length - b.purchasePrice.length,
  },
];

const items = [
  {
    label: <a href="/vendor">Vendorwise Outstanding</a>,
    key: "1",
  },
  {
    type: "divider",
  },
  {
    label: <a href="/vendor">Item Report By Vendor</a>,
    key: "2",
  },
];
const balaceCollectOptions = [
  // {
  //   label: "To Collect",
  //   value: "toCollect",
  // },
  {
    label: "To Pay",
    value: "toPay",
  },
];
const partyFaqList = [
  {
    key: "1",
    label: "Why should I create vendor?",
    children: (
      <p className="text-[12px]">
        vendor are your Customers and Suppliers. To make bills for them, you
        need to add them as a party first.
      </p>
    ),
  },
  {
    key: "2",
    label: "I have too many vendor. How to add them easily?",
    children: (
      <p className="text-[12px]">
        myBillBook provides the option to import your vendor data from Excel. To
        start uploading your vendor in bulk click here.
      </p>
    ),
  },
  {
    key: "3",
    label: "How to see vendor Ledger/Statement?",
    children: (
      <p className="text-[12px]">
        A vendor's ledger can be seen in two ways: <br />
        1. Select the vendor in the vendor table and then click on the
        "Ledger(Statement)" tab given at top in the new screen that opens.{" "}
        <br />
        2. You can also open vendor Statement by going to Reports from the side
        navigation menu and selecting "vendor Statement (Ledger)". After that,
        you can select the vendor whose vendor Statement you want to see.
      </p>
    ),
  },
  {
    key: "4",
    label: "How is vendor balance calculated?",
    children: (
      <p className="text-[12px]">
        vendor balance is the outstanding amount of money that you need to
        collect from or pay to the vendor. It is calculated based on the Opening
        Balance you entered while creating the vendor, the invoices(both sales
        and purchase) you made against the vendor and the payments you made
        to/received from the vendor.
      </p>
    ),
  },
  {
    key: "5",
    label: "How to send Invoice SMS to vendor?",
    children: (
      <p className="text-[12px]">
        For every Invoice that you create, an SMS is sent automatically to your
        vendor with a link to that Invoice. Incase you want to turn this feature
        off, you can do that by going to Reminder inside Settings and disabling
        the "Send billing SMS to vendor" option. To manually send SMS to vendor,
        open the Invoice and click on the SMS button.
      </p>
    ),
  },
  {
    key: "6",
    label: "How to create GST/Non-GST vendor?",
    children: (
      <p className="text-[12px]">
        While creating a vendor, enter their GSTIN. Accordingly that vendor will
        be counted as GST/Non-GST vendor. GSTIN along with Place of Supply of
        vendor will determine whether an Invoice will have IGST or CGST/SGST so
        make sure you fill this information.
      </p>
    ),
  },
];
// const vendorTypeOptions = [
//   {
//     label: "Customer",
//     value: "customer",
//   },
//   {
//     label: "Supplier",
//     value: "supplier",
//   },
// ];
const bulkActions = (
  <div className="hover:rounded-md hover:mr-[-3px] flex justify-between w-[270px] h-[45px] mt-[-12px] pl-3 pr-2 pt-2 pb-2 cursor-pointer">
    <div>
      <p className="flex text-[14px] font-semibold">
        <FileExcelOutlined className="mr-2" /> Bulk Add Vendor
      </p>
      <p className="mt-1 text-[12px]">Quickly add all your Vendor with Excel</p>
    </div>
    <BiRightArrowAlt size={24} />
  </div>
);
const partyTypeOptions = [
  {
    label: "Customer",
    value: "customer",
  },
  {
    label: "Supplier",
    value: "supplier",
  },
];
const ledgerStatementDetails = [
  {
    date: "",
    voucher: "Opening Balance",
    sNo: "-",
    key: "1",
    credit: "-",
    debit: "-",
    tdsDeductParty: "-",
    tdsDeductSelf: "-",
    balance: "0.0",
  },
  {
    date: "06 Aug 2024",
    voucher: "Sales Invoice",
    sNo: "1	",
    key: "2",
    credit: "75.0	",
    debit: "375.0",
    tdsDeductParty: "-",
    tdsDeductSelf: "-",
    balance: "300",
  },
  {
    date: "07 Aug 2024",
    voucher: "Purchase Record",
    sNo: "4",
    key: "3",
    credit: "900.0",
    debit: "_",
    tdsDeductParty: "_",
    tdsDeductSelf: "_",
    balance: "-600",
  },
  {
    date: "08 Aug 2024",
    voucher: "Sales Invoice",
    sNo: "6",
    key: "4",
    credit: "-",
    debit: "_",
    tdsDeductParty: "_",
    tdsDeductSelf: "_",
    balance: "-600",
  },
  {
    date: "12 Aug 2024",
    voucher: "Sales Invoice",
    sNo: "7",
    key: "5",
    credit: "-",
    debit: "125.0",
    tdsDeductParty: "_",
    tdsDeductSelf: "_",
    balance: "-475",
  },
  {
    date: "14 Aug 2024",
    voucher: "Payment out",
    sNo: "2",
    key: "6",
    credit: "-",
    debit: "900.0",
    tdsDeductParty: "_",
    tdsDeductSelf: "_",
    balance: "425",
  },
  {
    date: "14 Aug 2024",
    voucher: "Payment In",
    sNo: "4",
    key: "",
    credit: "825.0",
    debit: "900.0",
    tdsDeductParty: "_",
    tdsDeductSelf: "_",
    balance: "-400",
  },
  {
    date: "",
    voucher: "Closing Balance",
    sNo: "-",
    key: "1",
    credit: "350",
    debit: "-",
    tdsDeductParty: "-",
    tdsDeductSelf: "-",
    balance: "-350",
  },
];

const partySelectTabs = [
  {
    label: "Transactions",
    key: "1",
    icon: <BiCreditCard size={18} />,
  },
  {
    label: "Profile",
    key: "2",
    icon: <UserOutlined className="text-[16px]" />,
  },
  {
    label: "Ledger (Statement)",
    key: "3",
    icon: <ReadOutlined className="text-[16px]" />,
  },
  {
    label: "Item Wise Report",
    key: "4",
    icon: <ReadOutlined className="text-[16px]" />,
  },
];
const partySelectItems = [
  {
    label: <a href="/parties/data">Sales Invoice</a>,
    key: "1",
  },
  {
    type: "divider",
  },
  {
    label: <a href="/payment-in">Payment In</a>,
    key: "2",
  },
  {
    type: "divider",
  },
  {
    label: <a href="/parties/data">Quotation</a>,
    key: "3",
  },
  {
    type: "divider",
  },
  {
    label: <a href="/parties/data">Proforma Invoice</a>,
    key: "4",
  },
  {
    type: "divider",
  },
  {
    label: <a href="/parties/data">Sales Return</a>,
    key: "5",
  },
  {
    type: "divider",
  },
  {
    label: <a href="/parties/data">Delivery Challan</a>,
    key: "6",
  },
  {
    type: "divider",
  },
  {
    label: <a href="/parties/data">Purchase Order</a>,
    key: "7",
  },
];
const transactionsList = [
  {
    label: "Sales Invoice",
    key: "1",
  },

  {
    label: "Payment In",
    key: "2",
  },

  {
    label: "Quotation",
    key: "3",
  },

  {
    label: "Proforma Invoice",
    key: "4",
  },
  {
    label: "Sales Return",
    key: "5",
  },

  {
    label: "Delivery Challan",
    key: "6",
  },

  {
    label: "Purchase Order",
    key: "7",
  },
];
const ledgerStatementList = (
  <div className="hover:rounded-md hover:mr-[-3px] flex justify-between w-[130px] h-[60px] mt-[-12px] pl-3 pr-2 pt-2 pb-2 cursor-pointer">
    <div>
      <p className="flex border-x-0 border-t-0 text-[14px] font-semibold">
        <a href="/parties" className="flex">
          <MessageFilled className="mr-1" />
          SMS
        </a>
      </p>
      <Divider className="w-[185%] mt-[4px] ml-[-24px]" />
      <p className="flex mt-[-20px] text-[14px] font-semibold">
        <a href="/parties" className="flex">
          <WhatsAppOutlined className="mr-1" />
          Whatsapp
        </a>
      </p>
    </div>
  </div>
);
export {
  items,
  vendorHeaders,
  balaceCollectOptions,
  TableData,
  partyTypeOptions,
  partySelectTabs,
  partySelectItems,
  transactionsList,
  ledgerStatementDetails,
  ledgerStatementList,
  bulkActions,
  partyFaqList,
  itemHeaders,
};
